var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferEarn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.65926 9.77492L1.64594 8.76158C1.2326 8.34825 1.2326 7.66824 1.64594 7.25491L2.65926 6.24156C2.8326 6.06823 2.9726 5.72822 2.9726 5.48822V4.05487C2.9726 3.46821 3.4526 2.98822 4.03927 2.98822H5.4726C5.7126 2.98822 6.0526 2.84824 6.22593 2.67491L7.23926 1.66156C7.65259 1.24823 8.3326 1.24823 8.74593 1.66156L9.75928 2.67491C9.93261 2.84824 10.2726 2.98822 10.5126 2.98822H11.9459C12.5326 2.98822 13.0126 3.46821 13.0126 4.05487V5.48822C13.0126 5.72822 13.1526 6.06823 13.3259 6.24156L14.3393 7.25491C14.7526 7.66824 14.7526 8.34825 14.3393 8.76158L13.3259 9.77492C13.1526 9.94826 13.0126 10.2883 13.0126 10.5283V11.9615C13.0126 12.5482 12.5326 13.0283 11.9459 13.0283H10.5126C10.2726 13.0283 9.93261 13.1682 9.75928 13.3416L8.74593 14.3549C8.3326 14.7683 7.65259 14.7683 7.23926 14.3549L6.22593 13.3416C6.0526 13.1682 5.7126 13.0283 5.4726 13.0283H4.03927C3.4526 13.0283 2.9726 12.5482 2.9726 11.9615V10.5283C2.9726 10.2816 2.8326 9.94159 2.65926 9.77492Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferEarn);
export default __webpack_public_path__ + "static/media/ReferEarn.a71542bfcb136ce509624362f09c8d02.svg";
export { ForwardRef as ReactComponent };